import { Button } from '@mui/material'
import { Hicon, type HiconName } from './Hicon'

/**
 * Botão que abre e fecha um detalhe da tela (os achados, o diagnóstico). Contornado e com ícone,
 * para não passar despercebido como um link; a seta gira quando está aberto.
 */
export function BotaoExpandir({
  aberto,
  onClick,
  icone,
  children,
}: {
  aberto: boolean
  onClick: () => void
  icone: HiconName
  children: string
}) {
  return (
    <Button
      variant={aberto ? 'contained' : 'outlined'}
      disableElevation
      onClick={onClick}
      aria-expanded={aberto}
      startIcon={<Hicon name={icone} sx={{ fontSize: '1.1rem' }} />}
      endIcon={<Hicon name="chevron-down" sx={{ fontSize: '1rem', transition: 'transform 160ms ease', transform: aberto ? 'rotate(180deg)' : 'none' }} />}
      sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 2, px: 1.75, py: 0.75 }}
    >
      {children}
    </Button>
  )
}
